import { AccessKeys, AuthRules, FeatureKeys } from '../constants/auth-rules';
import {
  MSRAccessors, MicroServiceRuleIds,
} from '../constants/microservice-auth-rules';

const AuthManager = (() => {
  let store = {};

  const getState = () => store.getState();

  const getUserDetails = () => getState().user || {};

  const getUserAccessMap = () => getUserDetails().accessMap || {};

  return {
    init: (appStore) => {
      store = appStore;
    },
    updateStore: (appStore) => {
      store = appStore;
    },
    getAccessMapFromEntitlementMap: (entitlementMap) => ({
      [MicroServiceRuleIds.WORKFLOW_V4_LIST]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_LIST_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_CLONE]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_CLONE_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_CREATE]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_CREATE_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_GET]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_GET_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_DELETE]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_DELETE_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_ARCHIVE]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_ARCHIVE_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_GET_TEMPLATE]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_GET_TEMPLATE_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_GET_SCHEMA]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_GET_SCHEMA_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_GET_RULE]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_GET_RULE_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_LIST]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_LIST_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_CREATE]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_CREATE_ACCESSOR],
      [MicroServiceRuleIds.WORKFLOW_V4_GET_CONFIG]:
        entitlementMap[MSRAccessors.WORKFLOW_V4_GET_CONFIG_ACCESSOR],
      [MicroServiceRuleIds.EXCEL_GET_TEMPLATE]:
        entitlementMap[MSRAccessors.EXCEL_GET_TEMPLATE_ACCESSOR],
      [MicroServiceRuleIds.EXCEL_UPLOAD_FILE]:
        entitlementMap[MSRAccessors.EXCEL_UPLOAD_FILE_ACCESSOR],
      [MicroServiceRuleIds.EXCEL_UPDATE_MAPPING]:
        entitlementMap[MSRAccessors.EXCEL_UPDATE_MAPPING_ACCESSOR],
      [MicroServiceRuleIds.EXCEL_GET_AUTHORIZED_USERS]:
        entitlementMap[MSRAccessors.EXCEL_GET_AUTHORIZED_USERS_ACCESSOR],
      [MicroServiceRuleIds.LIST_USERS]: entitlementMap[MSRAccessors.LIST_USERS_ACCESSOR],
      [MicroServiceRuleIds.EXCEL_UPDATE_AUTHORIZED_USERS]:
        entitlementMap[MSRAccessors.EXCEL_UPDATE_AUTHORIZED_USERS_ACCESSOR],
      [MicroServiceRuleIds.CUSTOM_FIELDS_LIST]:
        entitlementMap[MSRAccessors.CUSTOM_FIELDS_LIST_ACCESSOR],
      [MicroServiceRuleIds.CUSTOM_FIELDS_CREATE]:
        entitlementMap[MSRAccessors.CUSTOM_FIELDS_CREATE_ACCESSOR],
      [MicroServiceRuleIds.CUSTOM_FIELDS_DELETE]:
        entitlementMap[MSRAccessors.CUSTOM_FIELDS_DELETE_ACCESSOR],
      [MicroServiceRuleIds.CUSTOM_FIELDS_UPDATE]:
        entitlementMap[MSRAccessors.CUSTOM_FIELDS_UPDATE_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_CREATE]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_CREATE_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_UPDATE]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_UPDATE_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_DELETE]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_DELETE_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_GET]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_GET_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_LIST]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_LIST_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_GET_FORM_FIELDS]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_GET_FORM_FIELDS_ACCESSOR],
      [MicroServiceRuleIds.TEMPLATE_V4_GENERATE_DOCUMENT]:
        entitlementMap[MSRAccessors.TEMPLATE_V4_GENERATE_DOCUMENT_ACCESSOR],
      [MicroServiceRuleIds.REPORT_READ_REPORT]:
        entitlementMap[MSRAccessors.REPORT_READ_REPORT_ACCESSOR],
      [MicroServiceRuleIds.REPORT_ORG_SCHEDULE_REPORT]:
        entitlementMap[MSRAccessors.REPORT_ORG_SCHEDULE_REPORT_ACCESSOR],
      [MicroServiceRuleIds.REPORT_ORG_TRIGGER_REPORT]:
        entitlementMap[MSRAccessors.REPORT_ORG_TRIGGER_REPORT_ACCESSOR],
      [MicroServiceRuleIds.AUTH_CREATE_OAUTH2_WEB_SERVER_CLIENT]:
        entitlementMap[MSRAccessors.AUTH_CREATE_OAUTH2_WEB_SERVER_CLIENT_ACCESSOR],
      [MicroServiceRuleIds.AUTH_CREATE_OAUTH2_SERVICE_CLIENT]:
        entitlementMap[MSRAccessors.AUTH_CREATE_OAUTH2_SERVICE_CLIENT_ACCESSOR],
      [MicroServiceRuleIds.AUTH_CREATE_OAUTH2_SELF_CLIENT]:
        entitlementMap[MSRAccessors.AUTH_CREATE_OAUTH2_SELF_CLIENT_ACCESSOR],
      [MicroServiceRuleIds.AUTH_CREATE_INVITATION]:
        entitlementMap[MSRAccessors.AUTH_CREATE_INVITATION_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_SEARCH_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_SEARCH_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_READ_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_READ_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_CREATE_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_CREATE_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_UPDATE_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_UPDATE_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_PUBLISH_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_PUBLISH_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_ARCHIVE_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_ARCHIVE_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_IMPORT_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_IMPORT_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_EXPORT_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_EXPORT_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_EXECUTE_SEQUENCE]:
        entitlementMap[MSRAccessors.AUTOMATION_EXECUTE_SEQUENCE_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_SEARCH_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_READ_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_READ_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_CREATE_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_CREATE_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_UPDATE_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_UPDATE_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_ARCHIVE_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_ARCHIVE_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_IMPORT_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_IMPORT_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_EXPORT_EVENT]:
        entitlementMap[MSRAccessors.AUTOMATION_EXPORT_EVENT_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_SEARCH_EVENT_RECORD]:
        entitlementMap[MSRAccessors.AUTOMATION_SEARCH_EVENT_RECORD_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_LIST_CONNECTOR]:
        entitlementMap[MSRAccessors.AUTOMATION_LIST_CONNECTOR_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_CREATE_CONNECTOR]:
        entitlementMap[MSRAccessors.AUTOMATION_CREATE_CONNECTOR_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_UPDATE_CONNECTOR]:
        entitlementMap[MSRAccessors.AUTOMATION_UPDATE_CONNECTOR_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_DELETE_CONNECTOR]:
        entitlementMap[MSRAccessors.AUTOMATION_DELETE_CONNECTOR_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_LIST_CREDENTIAL]:
        entitlementMap[MSRAccessors.AUTOMATION_LIST_CREDENTIAL_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_CREATE_CREDENTIAL]:
        entitlementMap[MSRAccessors.AUTOMATION_CREATE_CREDENTIAL_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_UPDATE_CREDENTIAL]:
        entitlementMap[MSRAccessors.AUTOMATION_UPDATE_CREDENTIAL_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_DELETE_CREDENTIAL]:
        entitlementMap[MSRAccessors.AUTOMATION_DELETE_CREDENTIAL_ACCESSOR],
      [MicroServiceRuleIds.AUTOMATION_SEARCH_ACTIVITY_LOG]:
        entitlementMap[MSRAccessors.AUTOMATION_SEARCH_ACTIVITY_LOG_ACCESSOR],
      [MicroServiceRuleIds.LEE_AI_START_CONVERSATION]:
        entitlementMap[MSRAccessors.LEE_AI_START_CONVERSATION_ACCESSOR],
    }),
    getAccessMapFromTags: (accessTags) => ({
      [AccessKeys.ORG_ADMIN]: accessTags.isOrgAdmin,
      [AccessKeys.ORG_BILLING_ADMIN]: accessTags.isOrgBillingAdmin,
      [AccessKeys.BILLING_PROFILE_EXISTS]: accessTags.billingProfileExists,
      [AccessKeys.DEPARTMENT_OWNER]: accessTags.isDepartmentOwner,
      [AccessKeys.ORG_USER]: accessTags.isOrgUser,
      [AccessKeys.STAMP_ACCESS]: accessTags.isStampingAccess,
      [AccessKeys.NOTIFICATIONS]: accessTags.customNotificationAccess,
      [AccessKeys.CONTACT_BOOK]: accessTags.isContactBookAccess,
      [AccessKeys.BULK_REQ_PROFILE]: accessTags.bulkRequestProfileAccess,
      [AccessKeys.NEW_DOC_ACCESS]: accessTags.newDocAccess,
      [AccessKeys.CONTACT_BOOK_ACTIVATED]: accessTags.contactBookActivated,
      [AccessKeys.MFA_ACCESS]: accessTags.isMFAAccess,
      [AccessKeys.NESL_ACCESS]: accessTags.isNeslAccess,
      [AccessKeys.SFTP_ACCESS]: accessTags.isSFTPAccess,
      [AccessKeys.EXCEL_UPLOAD_ACCESS]: accessTags.isExcelUploadAccess,
      [AccessKeys.EMAIL_EXCEL_UPLOAD_ACCESS]: accessTags.isEmailExcelUploadAccess,
      [AccessKeys.BRAND_COLOUR_ACCESS]: accessTags.isColourBrandingAccess,
      [AccessKeys.BRAND_LOGO_ACCESS]: accessTags.isLogoBrandingAccess,
      [AccessKeys.CORNER_RADIUS_BRANDING_ACCESS]: accessTags.isCornerRadiusBrandingAccess,
      [AccessKeys.AUTO_CHECK_CONSENT_ACCESS]: accessTags.isAutoCheckConsentAccess,
      [AccessKeys.MULTI_BRANDING_PROFILE_ACCESS]: accessTags.isMultiBrandingProfileAccess,
      [AccessKeys.BRANDING_PROFILE_LIMIT]: accessTags.brandingProfileLimit,
      [AccessKeys.MULTI_STAMPING_ACCESS]: accessTags.isMultiStampingAccess,
      [AccessKeys.MULTI_STAMP_SERIES_ACCESS]: accessTags.isMultiStampSeriesAccess,
      [AccessKeys.TWO_FACTOR_AUTHENTICATION_ACCESS]: accessTags.twoFactorAuthenticationAccess,
      [AccessKeys.REVENUE_STAMPING_ACCESS]: accessTags.isRevenueStampAccess,
      [AccessKeys.AADHAAR_ACCESS]: accessTags.isAadhaarAccess,
      [AccessKeys.VIRTUAL_SIGN_BIO_ACCESS]: accessTags.isVirBioAccess,
      [AccessKeys.PHYSICAL_SIGNATURE_ACCESS]: accessTags.isPhysicalSignatureAccess,
      [AccessKeys.OFFLINE_ESIGN_ACCESS]: accessTags.isOfflineEsignAccess,
      [AccessKeys.OFFLINE_ESIGN_FOREIGN_ACCESS]: accessTags.isOfflineEsignForeignAccess,
      [AccessKeys.AUTOMATED_SIGN_ACCESS]: accessTags.isAutomatedAccess,
      [AccessKeys.DOC_SIGNER_ACCESS]: accessTags.isDocAccess,
      [AccessKeys.DSC_SIGN_ACCESS]: accessTags.isDscAccess,
      [AccessKeys.BULK_DSC_SIGNING_ACCESS]: accessTags.isBulkSignAccess,
      [AccessKeys.VIRTUAL_SIGN_ACCESS]: accessTags.isVirtualAccess,
      [AccessKeys.SMART_NAME_AI_ACCESS]: accessTags.isSmartNameAIAccess,
      [AccessKeys.SMART_USER_LIVELINESS_ACCESS]: accessTags.isSmartUserLivelinessAccess,
      [AccessKeys.SMART_USER_LIVELINESS_V2_ACCESS]: accessTags.smartUserLivelinessV2Access,
      [AccessKeys.APPROVER_ACCESS]: accessTags.isApproverAccess,
      [AccessKeys.GROUP_INVITEES_ACCESS]: accessTags.isGroupInviteesAccess,
      [AccessKeys.CC_ACCESS]: accessTags.isCCAccess,
      [AccessKeys.CAPTURE_LOCATION_ACCURACY]: accessTags.captureLocationAccuracy,
      [AccessKeys.CAPTURE_LOCATION_ACCESS]: accessTags.captureLocationAccess,
      [AccessKeys.COORDINATE_PICKER_ACCESS]: accessTags.isCoordinatePickerAccess,
      [AccessKeys.REGIONAL_LANGUAGE_ACCESS]: accessTags.isRegionalLanguageAccess,
      [AccessKeys.PII_MASKING_ACCESS]: accessTags.piiMaskingAccess,
      [AccessKeys.CAPTURE_FACE_ACCESS]: accessTags.captureFaceAccess,
      [AccessKeys.FACE_MATCH_ACCESS]: accessTags.isFaceMatchAccess,
      [AccessKeys.WHATSAPP_ACCESS]: accessTags.isWhatsAppAccess,
      [AccessKeys.PAYMENT_COLLECTION]: accessTags.paymentCollection?.isPaymentCollectionAccess,
      [AccessKeys.SENDING_SDK_ACCESS]: accessTags.sendingSdkAccess,
      [AccessKeys.API_ACCESS]: accessTags.isAPIAccess,
      [AccessKeys.SFTP_COUNT]: accessTags.sftpCount,
      [AccessKeys.PDF_EDITOR_ACCESS]: accessTags.isPdfEditorAccess,
      [AccessKeys.QUICK_SIGN_ACCESS]: accessTags.isQuickSignAccess,
      [AccessKeys.QUICK_SIGN_BIO_ACCESS]: accessTags.isQuickSignBioAccess,
      [AccessKeys.QUICK_PHYSICAL_SIGN_ACCESS]: accessTags.isQuickSignPhysicalSignatureAccess,
      [AccessKeys.VISUAL_SIGN_ACCESS]: accessTags.isVisualSignAccess,
      [AccessKeys.VISUAL_SIGN_BIO_ACCESS]: accessTags.isVisualSignBioAccess,
      [AccessKeys.VISUAL_SIGN_PHYSICAL_ACCESS]: accessTags.isVisualSignPhysicalSignatureAccess,
      [AccessKeys.EBG_NOTIFICATION_ACCESS]: accessTags.isEbgNotificationAccess,
      [AccessKeys.DC_ACCESS]: accessTags.dcAccess,
      [AccessKeys.STAMP_GROUP_ACCESS]: accessTags.isStampingAccess
      && accessTags.isMultiStampingAccess,
      [AccessKeys.WORKFLOW_V4_ACCESS]: accessTags.workflowV4Access,
      [AccessKeys.AUTOMATION_MODULE_ACCESS]: accessTags.automationModuleAccess,
      [AccessKeys.PACK_MULTI_DOC_ACCESS]: accessTags.packMultiDocAccess,
      [AccessKeys.RULE_ENGINE_ACCESS]: accessTags.ruleEngineAccess,
      [AccessKeys.CUSTOM_FIELDS_ACCESS]: accessTags.customFieldsAccess,
      [AccessKeys.CUSTOM_VALIDATIONS_ACCESS]: accessTags.customValidationsAccess,
      [AccessKeys.CUSTOM_SENDING_UI_ACCESS]: accessTags.customSendingUiAccess,
      [AccessKeys.CUSTOM_FIELD_PAGE_ACCESS]: accessTags.customFieldPageAccess,
      [AccessKeys.DISTRIBUTED_STAMPING_ACCESS]: accessTags.distributedStampingAccess,
      [AccessKeys.DIGITAL_STAMPING_ACCESS]: accessTags.isDigitalStampAccess,
      [AccessKeys.LEE_AI_AGENT_ACCESS]: accessTags.isLeeAIAgentAccess,
      [AccessKeys.REPORTS_ACCESS]: accessTags.reportsAccess,
      [AccessKeys.ADVANCED_SIGNING_ORDER_ACCESS]: accessTags.isAdvancedSigningOrderAccess,
      [AccessKeys.SIGN_COMBINATION_ACCESS]: accessTags.signCombinationAccess,
    }),
    isAuthenticated: () => !!getUserDetails().authenticated,
    isAuthorised: (featureKey) => !!(AuthRules[featureKey](getUserAccessMap())),
    getAccessValue: (accessKey) => getUserAccessMap()[accessKey],
  };
})();

export {
  AuthManager as default,
  AccessKeys,
  AuthRules,
  FeatureKeys,
};
